import {css} from 'lit';
export const styles = css`paper-progress {
    --paper-progress-active-color: var(--app-primary-color-400);
    --paper-progress-container-color: rgba(255, 255, 255, 1);
    --paper-progress-indeterminate-cycle-duration: 2s;
    width: 100%;
    display: block;
}`;
export default styles;
